<template>
  <v-list-item>
    <!-- <v-list-item-avatar>
      <v-icon
        :class="[item.iconClass]"
        v-text="item.icon"
      ></v-icon>
    </v-list-item-avatar> -->

    <v-list-item-content>
      <v-list-item-title>{{ user.first_name }} {{ user.last_name }}</v-list-item-title>
      <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn
        icon
        @click="removeShare"
      >
        <v-icon>mdi-account-remove</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import http from '@/http';

export default {
  name: 'ShareListItem',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async removeShare() {
      await http.request({
        url: '/neuralike-user/share/',
        method: 'delete',
        data: {
          id: this.user.id,
        },
      });
      this.$emit('deleted');
    },
  },
};
</script>
